import { Alert, Badge, borderRadius, breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const EarningsWidgetRoot = styled.div`
  width: 100%;
  margin-top: 14px;
`;

export const WidgetGroup = styled.div`
  ${borderRadius.r2};
  position: relative;
  border: 1px solid var(--border-primary);
  padding: 32px 16px 20px;
  margin-bottom: 24px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const WidgetBadge = styled(Badge).attrs({
  badgeStyle: 'outline',
  color: 'primary',
  size: 'medium',
})`
  top: 0;
  left: 16px;
  position: absolute;
  transform: translateY(-50%);
  background-color: var(--background-default);
  outline: 6px solid var(--background-default);

  @media ${breakpoints.lg} {
    background-color: var(--background-soft);
    outline-color: var(--background-soft);
  }

  @media screen and (min-width: 1920px) {
    background-color: var(--background-default);
    outline-color: var(--background-default);
  }
`;

export const AnalyzeAlert = styled(Alert)`
  width: 100%;
  margin-bottom: 40px;
`;
